import { t } from 'i18next';
import { ArrowLeft } from '@peacecover/icon';
import ProfileAvatar from '../../presentation/my-page/components/ProfileAvatar';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';

export default function HomeHeader({
  user,
  title = t('feedPage.title'),
  onClickTitle,
  onClickProfileButton
}) {
  const handleHistoryBack = useHandleHistoryBack();
  return (
    <div className="flex flex-row items-center justify-between px-[16px] py-[10px]">
      <ArrowLeft size={24} className="text-text-main-lv1" onClick={handleHistoryBack} />
      <h1 className="text-[17px] font-bold text-text-main-lv1 leading-none">{title}</h1>
      <button type="button" onClick={onClickProfileButton}>
        <ProfileAvatar
          thumbnailUrl={user?.baseUserProfile?.thumbnailUrl}
          widthAndHeight="24px"
          svgWidthAndHeight="24px"
        />
      </button>
    </div>
  );
}
